<cv-reportingset-dynamic-filters *ngIf="filterableFields"
    [externalReportFilterableFields]="filterableFields"
    [moduleManager]="moduleManager">
</cv-reportingset-dynamic-filters>